import { Autocomplete, TextField, Typography } from "@mui/material";

import { useField } from "formik";
import { useRef, useState } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 240,
    },
  },
};

export const MultiSelectFormControl = ({
  id,
  label,
  options,
  value,
  handleSubmit,
}: any) => {
  const [field, meta, helpers] = useField(id);
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Autocomplete
      id={id}
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      size="small"
      sx={{
        width: "256px",
        "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
          {
            paddingRight: 0,
          },
      }}
      onChange={(_, newValue) => {
        helpers.setValue(newValue || "");
        handleSubmit();
      }}
      renderTags={(selected, getTagProps) => (
        <Typography
          onClick={() => {
            setOpen(true);
            inputRef.current?.focus();
          }}
          component="div"
          variant="body1"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "200px",
            maxWidth: "calc(100% - 50px)",
            cursor: "pointer",
          }}
        >
          {selected.join(",")}
        </Typography>
      )}
      options={options}
      value={value}
      renderInput={(params) => (
        <TextField {...params} inputRef={inputRef} label={label} />
      )}
    />
  );
};
